import * as React from 'react'
import { useTranslation } from 'react-i18next';
import {
    CheckboxVisibility,
    DetailsList,
    IColumn,
    Label,
    Modal,
    SelectionMode,
} from '@fluentui/react';
import * as Api from "../../api/src"
import ModalHeader from '../../control/modalHeader';

const UserApi = new Api.UserApi();
const VendorApi = new Api.VendorsApi();

export interface ModalSwitchCompanyProps {
    IsOpen: boolean,
    onCloseModal: () => void;
    onSaveModal: (data: Api.TokenResponse) => void;
    Item: number
}
const ModalSwitchCompany = ({ IsOpen, onCloseModal, onSaveModal, Item }: ModalSwitchCompanyProps) => {
    const { t } = useTranslation();
    const [isShow, SetIsShow] = React.useState(false);
    const [listVendors, SetListVendors] = React.useState<Api.VendorModel[]>([]);
    
    React.useEffect(() => {
        if (IsOpen) {
            SetIsShow(IsOpen);
            getData();
        }
    }, [IsOpen]);

    const getData = async () => {
        let data = (await (UserApi.apiUserIdGet(Item))).data;
        if (data) {
            SetListVendors(data.Data?.Vendors ?? []);
        }
    }

    const _columns = [
        {
          key: 'Vendor',
          name: t('Vendor'),
          className: 'flex-center',
          minWidth: 400,
          maxWidth: 400,
          isResizable: true,
          onRender: (item: Api.VendorModel) => {
            return (
              <div>
                <Label>{item.Name}</Label>
                {item.InUse && <Label style={{color: 'gray', fontSize: 12}}>{"Current logged-in"}</Label>}
              </div>
            );
          },
        },
      ] as IColumn[];

      const handleRowClick = async (item: Api.VendorModel) => {
        if(item.InUse) return; 
        let data = await VendorApi.apiVendorsSwitchIdGet(item.Id ?? 0);
        onSaveModal(data.data);
        SetIsShow(false);
      };

    const onClose = () => {
        onCloseModal()
        SetIsShow(false)
    }
    
    return (
        <Modal
            isOpen={isShow}
            isModeless={true}
        >
            <ModalHeader title={t('SwitchCompany')} onCloseModal={() => {
                onClose();
            }} />
            <div className={'modal-content'} style={{ width: 500 }}>
                <DetailsList items={listVendors} columns={_columns} checkboxVisibility={CheckboxVisibility.hidden}
                    isHeaderVisible={false}
                    selectionMode={SelectionMode.single}
                    onActiveItemChanged={handleRowClick}/>
            </div>
            
        </Modal>
    );
}
export default ModalSwitchCompany;